export default __webpack_public_path__ + "static/media/contactTitle.b11a6108.jpg";